import { createReducer } from '@reduxjs/toolkit'
import { createSelector } from 'reselect'

import { deleteJob, getJobs, getJob, addJob, resetJob, editJob } from './job.actions'
import { logout } from '../user/user.action'

const initialState = {
  jobs: [],
  jobsPage: 0,
  jobsTotal: 0,
  jobsPageSize: 0,

  job: null,

  loading: {
    getJobs: false,
    getJob: false,
    addJob: false,
    editJob: false,
    deleteJob: false,
  },
  error: {
    getJobs: false,
    getJob: false,
    addJob: null,
    editJob: null,
    deleteJob: false,
  },
}

const jobReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getJobs.fulfilled, (state, action) => {
      state.jobs = action.payload.results
      state.jobsPage = action.payload.page
      state.jobsTotal = action.payload.total
      state.jobsPageSize = action.payload.page_size

      state.loading.getJobs = false
      state.error.getJobs = false
    })
    .addCase(getJobs.pending, (state) => {
      state.loading.getJobs = true
      state.error.getJobs = false
    })
    .addCase(getJobs.rejected, (state) => {
      state.loading.getJobs = false
      state.error.getJobs = true
    })

    .addCase(getJob.fulfilled, (state, action) => {
      state.job = action.payload

      state.loading.getJob = false
      state.error.getJob = false
    })
    .addCase(getJob.pending, (state) => {
      state.loading.getJob = true
      state.error.getJob = false
    })
    .addCase(getJob.rejected, (state) => {
      state.loading.getJob = false
      state.error.getJob = true
    })

    .addCase(addJob.fulfilled, (state) => {
      state.loading.addJob = false
      state.error.addJob = null
    })
    .addCase(addJob.pending, (state) => {
      state.loading.addJob = true
      state.error.addJob = null
    })
    .addCase(addJob.rejected, (state, action) => {
      state.loading.addJob = false
      state.error.addJob = action.error?.message || null
    })

    .addCase(editJob.fulfilled, (state) => {
      state.loading.editJob = false
      state.error.editJob = null
    })
    .addCase(editJob.pending, (state) => {
      state.loading.editJob = true
      state.error.editJob = null
    })
    .addCase(editJob.rejected, (state, action) => {
      state.loading.editJob = false
      state.error.editJob = action.error?.message || null
    })

    .addCase(deleteJob.fulfilled, (state) => {
      state.loading.deleteJob = false
      state.error.deleteJob = false
    })
    .addCase(deleteJob.pending, (state) => {
      state.loading.deleteJob = true
      state.error.deleteJob = false
    })
    .addCase(deleteJob.rejected, (state) => {
      state.loading.deleteJob = false
      state.error.deleteJob = true
    })

    .addCase(resetJob, (state) => {
      state.job = null
      state.loading.deleteJob = false
      state.error.deleteJob = false
    })

    .addCase(logout.fulfilled, () => initialState)

    .addDefaultCase((state) => state)
})

const jobState = (state) => state.job

export const selectJobs = createSelector(jobState, ({ jobs }) => jobs)

export const selectJobsPagination = createSelector(
  jobState,
  ({ jobs, jobsPage, jobsTotal, jobsPageSize }) => ({ jobs, jobsPage, jobsTotal, jobsPageSize })
)

export const selectJob = createSelector(jobState, ({ job }) => job)

export const selectJobsLoading = createSelector(jobState, ({ loading: { getJobs } }) => getJobs)

export const selectJobLoading = createSelector(jobState, ({ loading: { getJob } }) => getJob)

export const selectAddJobLoading = createSelector(jobState, ({ loading: { addJob } }) => addJob)

export const selectAddJobError = createSelector(jobState, ({ error: { addJob } }) => addJob)

export const selectEditJobLoading = createSelector(jobState, ({ loading: { editJob } }) => editJob)

export const selectEditJobError = createSelector(jobState, ({ error: { editJob } }) => editJob)

export const selectDeleteJobLoading = createSelector(
  jobState,
  ({ loading: { deleteJob } }) => deleteJob
)

export default jobReducer
